import theme from '@qnpm/q-theme';
const { responsive: { scale } } = theme;
/**
 * 将字符串类型的数字字符串转换为number类型
 * @param value 数字or数字字符串
 */
function formatNumber(value, needScale) {
    if (typeof value === 'string') {
        return scale(parseFloat(value), needScale);
    }
    return scale(value || 0, needScale);
}
/**
 * 获取单选按钮的margin值
 * @param style 外部定义的按钮样式
 */
export function getComponentMargin(style, scale) {
    const { marginLeft, marginRight, marginTop, marginBottom, marginHorizontal, marginVertical } = style || {};
    return {
        marginLeft: formatNumber(marginLeft, scale),
        marginRight: formatNumber(marginRight, scale),
        marginTop: formatNumber(marginTop, scale),
        marginBottom: formatNumber(marginBottom, scale),
        marginHorizontal: formatNumber(marginHorizontal, scale),
        marginVertical: formatNumber(marginVertical, scale)
    };
}
export function getComponentStyle(props) {
    const { needScale = false } = props;
    const defaultWidth = scale(20, needScale);
    const defaultSize = { width: defaultWidth, height: defaultWidth };
    const { size = defaultSize } = props;
    return {
        wrapper: Object.assign({}, size)
    };
}
